import { useState, useEffect } from 'react';

/**
 * 미디어 쿼리 훅. MUI useMediaQuery 대체.
 * @param query - CSS 미디어 쿼리 문자열 (예: '(max-width: 600px)')
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    setMatches(mediaQuery.matches);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

/** 모바일(sm 이하, 600px) 여부 */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 600px)');
}
